import React, { useEffect, useState } from 'react';
import { Formik, Field, Form } from 'formik';
import * as Yup from 'yup';
import { Input, Select } from '../../../../_metronic/_partials/controls';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import * as reqDistrict from '../../MasterData/_redux/province/provinceCrud';
import * as reqCategory from '../../MasterData/_redux/master-category/MasterCategoryCrud'
import { isAlive, isActive, type, greetingValue, letterChoice } from '../DonaturUIHelpers'
import {
    Checkbox,
    FormControlLabel,
} from "@material-ui/core";


const DonaturEditForm = ({ donatur, btnRef, saveDonatur, parent_uuid }) => {
    const [district, setDistrict] = useState([]);
    const [postalCode, setPostalCode] = useState([]);
    const [showPIC, setShowPIC] = useState('INDIVIDU')
    const [kotaValue, setKotaValue] = useState('')
    const [userCategoryList, setUserCategoryList] = useState([]);

    let DonaturEditSchema = DonaturEditSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, 'Minimun 2 Character')
            .required('Nama wajb diisi'),
        // hp: Yup.string(),
        // email: Yup.string().email()
    });
    // Validation schema
    // if (!parent_uuid) {
    //     DonaturEditSchema = Yup.object().shape({
    //         name: Yup.string()
    //             .min(2, 'Minimun 2 Character')
    //             .max(100, 'Maximum 100 Character')
    //             .required('Nama wajb diisi'),
    //         hp: Yup.string().required('Hp wajb diisi'),
    //         email: Yup.string().email().required('Email wajb diisi'),
    //     });
    // } else {
    //     DonaturEditSchema = Yup.object().shape({
    //         name: Yup.string(),
    //         hp: Yup.string(),
    //         email: Yup.string().email()
    //     });
    // }

    const onInputChange = (e) => {
        const value = e.target.value;

        if (value.length >= 3) {
            let query = {
                district: value,
                city: value,
            };
            reqDistrict.findDistrict(query).then(response => {
                setDistrict(response.data.data);
            })
        }
    };

    const onTypeChange = (value, setFieldValue) => {
        if (value === 'LEMBAGA' || value === "KOMUNITAS") {
            setShowPIC(value)
        } else {
            setShowPIC('INDIVIDU')
        }
    }

    const onSelectTag = (value, setFieldValue) => {
        if (value) {
            const array = value.split(',');
            if (array.length === 3) {
                let index = district.findIndex(i => i.district === array[0].trim() && i.city === array[1].trim() && i.province_name === array[2].trim());

                setPostalCode(district[index].postalcode);

                setFieldValue('province', district[index].province_name);
                setFieldValue('city', district[index].city);
                setFieldValue('district', district[index].district);
                setKotaValue(`${district[index].district}, ${district[index].city}, ${district[index].province_name}`)
            }
        } else {
            setPostalCode([]);
            setFieldValue('province', '');
            setFieldValue('city', '');
            setFieldValue('district', '');
            setKotaValue('')
            setFieldValue('postal_code', '')
        }

    }

    useEffect(() => {
        let value = donatur.district;
        let query = {
            district: value,
            city: value,
        };

        if (donatur.district !== null) {
            if (donatur.district !== '') {
                reqDistrict.findDistrict(query).then(response => {
                    setPostalCode(response.data.data[0].postalcode);
                });
            }
        }


        reqCategory.getMasterCategoryAll().then(response => {
            setUserCategoryList(response.data.data.rows);
        })


        if (donatur.name) {
            if (!donatur.district && !donatur.city && !donatur.province) {
                setKotaValue(``)

            } else {
                setKotaValue(`${donatur.district}, ${donatur.city}, ${donatur.province}`)

            }
        } else {
            setKotaValue(``)
        }

        donatur.type === '' ? setShowPIC("INDIVIDU") : setShowPIC(donatur.type)
        // eslint-disable-next-line
    }, [donatur])

    return (
        <div>
            <Formik
                enableReinitialize={true}
                initialValues={donatur}
                validationSchema={DonaturEditSchema}
                onSubmit={(values) => {
                    if (values.type === '') {
                        values.type = 'INDIVIDU'
                    }
                    saveDonatur(values);
                }}>
                {({ handleSubmit, handleChange, setFieldValue, values, isSubmitting }) => (
                    <>
                        <Form className="form form-label-right">
                            <div className="form-group row">
                                <div className="col-lg-3">
                                    <Select
                                        name="type"
                                        label="Tipe Donatur"
                                        disabled={parent_uuid}
                                        onChange={(e) => {
                                            onTypeChange(e.target.value, setFieldValue);
                                            setFieldValue('type', e.target.value)
                                        }}
                                    >
                                        {
                                            type.map(row =>
                                                <option key={row.value} value={row.value}>{row.name}</option>
                                            )
                                        }
                                    </Select>
                                </div>
                                {(showPIC === "LEMBAGA" || showPIC === "KOMUNITAS") && (
                                    <>
                                        <div className="col-lg-4">
                                            <Field
                                                name="pic"
                                                component={Input}
                                                placeholder="Nama PIC"
                                                label="Nama PIC"
                                            />
                                        </div>
                                        <div className="col-lg-3">
                                            <Field
                                                name="pic_email"
                                                component={Input}
                                                placeholder="Email PIC"
                                                label="Email PIC"
                                            />
                                        </div>
                                        <div className="col-lg-2">
                                            <Field
                                                name="pic_hp"
                                                component={Input}
                                                placeholder="Nomor hp PIC"
                                                label="Nomor PIC"
                                            />
                                        </div>
                                    </>
                                )}

                            </div>
                            <div className="form-group row">
                                <div className="col-lg-3">
                                    <Select
                                        name="category_uuid"
                                        label="Kategori Donatur"
                                        disabled={parent_uuid}
                                        onChange={(e) => {
                                            // onTypeChange(e.target.value, setFieldValue);
                                            setFieldValue('category_uuid', e.target.value)
                                        }}
                                    >
                                        <option value="">Tidak Berkategori</option>
                                        {
                                            userCategoryList.map(row =>
                                                <option key={row.uuid} value={row.uuid}>{row.name}</option>
                                            )
                                        }
                                    </Select>
                                </div>
                            </div>
                            <hr />
                            <div className="form-group row">
                                <div className="col-lg-2">
                                    <Select
                                        name="greeting"
                                        label="Sapaan"
                                    >
                                        <option value="">-PILIH-</option>
                                        {
                                            greetingValue.map(row =>
                                                <option key={row.value} value={row.value}>{row.value}</option>
                                            )
                                        }
                                    </Select>
                                </div>
                                <div className="col-lg-4">
                                    <Field
                                        name="name"
                                        component={Input}
                                        placeholder="Name"
                                        label="Nama Lengkap"
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <Field
                                        name="hp"
                                        component={Input}
                                        placeholder="Untuk Indonesia 08xx, Untuk Luar +72xx"
                                        label="No. Hp"
                                    />
                                </div>
                                <div className="col-lg-3">
                                    <Field
                                        name="email"
                                        component={Input}
                                        placeholder="Email"
                                        label="Email"
                                    />
                                </div>
                            </div>


                            <div className="form-group row">
                                <div className="col-lg-8">
                                    <Autocomplete
                                        id="searchPostalCode"
                                        // disableClearable
                                        onChange={(e, value) => {
                                            onSelectTag(value, setFieldValue);
                                        }}
                                        value={kotaValue}
                                        options={
                                            district.map((option) => `${option.district}, ${option.city}, ${option.province_name}`)
                                        }
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Cari Kota / Kecamatan"
                                                margin="normal"
                                                variant="outlined"
                                                InputProps={{ ...params.InputProps, type: 'search' }}
                                                onChange={
                                                    (e) => {
                                                        onInputChange(e);
                                                    }}
                                            />
                                        )}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <Select
                                        name="postal_code"
                                        label="Kodepos"
                                    >
                                        <option value="">-PILIH-</option>
                                        {
                                            postalCode.map(row =>
                                                <option key={row} value={row}>{row}</option>,
                                            )
                                        }
                                    </Select>
                                </div>
                            </div>

                            <div className="form-group row" style={{ display: "none" }}>
                                <div className="col-lg-3">
                                    <Field
                                        name="province"
                                        component={Input}
                                        placeholder="Provinsi"
                                        label="Provinsi"
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <Field
                                        name="city"
                                        component={Input}
                                        placeholder="Kota"
                                        label="Kota"
                                        disabled={true}

                                    />
                                </div>
                                <div className="col-lg-3">
                                    <Field
                                        name="district"
                                        component={Input}
                                        placeholder="Kecamatan"
                                        label="Kecamatan"
                                        disabled={true}
                                    />
                                </div>

                            </div>
                            <div className="form-group">
                                <Field
                                    name="address"
                                    component={Input}
                                    placeholder="Address"
                                    label="Address"
                                />
                            </div>

                            <div className="form-group row">
                                <div className="col-lg-4">
                                    <Field
                                        name="nik"
                                        component={Input}
                                        placeholder="NIK / Nomor KTP / Nomor Perusahaan"
                                        label="NIK / Nomor KTP / Nomor Perusahaan"
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <Field
                                        name="npwp"
                                        component={Input}
                                        placeholder="NPWP"
                                        label="NPWP"
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <Field
                                        name="npwz"
                                        component={Input}
                                        placeholder="NPWZ"
                                        label="NPWZ"
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                {(showPIC === 'INDIVIDU' || parent_uuid || showPIC === '') && (
                                    <>
                                        <div className="col-lg-4">
                                            <Select
                                                name="is_alive"
                                                label="Status Hidup"
                                            >
                                                {isAlive.map(row =>
                                                    <option key={row.value} value={row.value}>{row.name}</option>
                                                )}

                                            </Select>
                                        </div>

                                    </>
                                )}

                                <div className="col-lg-4">
                                    <Select
                                        name="is_active"
                                        label="Keaktifan"
                                    >
                                        {
                                            isActive.map(row =>
                                                <option key={row.value} value={row.value}>{row.name}</option>
                                            )
                                        }
                                    </Select>
                                </div>

                                <div className="col-lg-4">
                                    <Field
                                        name="kode_rekening"
                                        component={Input}
                                        placeholder="Kode Tag"
                                        label="Kode Rekening"
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-lg-4">
                                    <Select
                                        name="is_letters"
                                        label="Terima Hard Copy"
                                    >
                                        <option value="">-PILIH-</option>
                                        {letterChoice.map(row =>
                                            <option key={row.name} value={row.value}>{row.name}</option>
                                        )}
                                    </Select>
                                </div>
                            </div>

                            {/* <div className="form-group row">
                                <div className="col-lg-4">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="is_email"
                                            />
                                        }
                                        label="Notifikasi Email"
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="is_letters"
                                            />
                                        }
                                        label="Notifikasi Pengiriman Surat"
                                    />
                                </div>
                            </div> */}

                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={btnRef}
                                onSubmit={() => handleSubmit()}
                                disabled={isSubmitting}
                            ></button>
                        </Form>
                    </>
                )}

            </Formik>

        </div>
    );
};

export default DonaturEditForm;
